import { configureStore } from "@reduxjs/toolkit";

import userReducer from "./reducers/user";
import { loadState } from "../utils/useLocalStorage";

const preloadedState = {
  user: {
    value: loadState("user"),
  },
};

const store = configureStore({
  reducer: {
    user: userReducer,
  },
  preloadedState,
});

export default store;
